var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import * as actions from '../../store/orgDevPlan/actions';
import { makeSelectDevPlans, makeSelectActiveDeveloperPlan, makeSelectActiveBundles, selectActiveBundlesOrg, selectDeveloperPlanConsumeOrg, selectDeveloperPlansOrg, selectDevPlanInvoiceDetailsOrg, selectDevPlanInvoiceDetails, selectPurchaseDevPlanBundleLoading, selectPurchaseDevPlanBundleError, } from '../../store/orgDevPlan/selectors';
import { makeSelectOrganization } from '../Root/selectors';
import { useSuccessToast } from '../../utils/hooks/toast';
import DevPlanCancelConfirmModal from '../../components/DeveloperPlans/DevPlanCancelConfirmModal';
import { Helmet } from 'react-helmet';
import { PageHeader, PageHeaderTitle, PageWrapper, } from '../../components/Page';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import DevPlanUsageComponent from '../../components/DeveloperPlans/DevPlanUsageComponent';
import { selectDevPlanSummery, selectStatusLoading, selectStatusSummeryOrg, } from '../../store/orgStatusSummery/selectors';
var OrganizationDeveloperPlansUsage = function (_a) {
    var organization = _a.organization, devPlanStatus = _a.devPlanStatus, devPlanStatusOrg = _a.devPlanStatusOrg, devPlanStatusLoading = _a.devPlanStatusLoading, cancelDevPlan = _a.cancelDevPlan, devPlanCancel_error = _a.devPlanCancel_error, devPlanCancel_loading = _a.devPlanCancel_loading, reactivateDevPlan = _a.reactivateDevPlan, devPlanReactivate_error = _a.devPlanReactivate_error, devPlanReactivate_loading = _a.devPlanReactivate_loading, getConsumedDevPlan = _a.getConsumedDevPlan, devPlanConsume = _a.devPlanConsume, activeDeveloperPlan = _a.activeDeveloperPlan, activeBundles = _a.activeBundles, activeBundlesOrg = _a.activeBundlesOrg, developerPlanPurchase_loading = _a.developerPlanPurchase_loading, developerPlanPurchase_error = _a.developerPlanPurchase_error, purchasedDeveloperPlan = _a.purchasedDeveloperPlan, listDeveloperPlans = _a.listDeveloperPlans, getActiveBundles = _a.getActiveBundles, devPlanConsumeOrg = _a.devPlanConsumeOrg, developerPlansOrg = _a.developerPlansOrg, bundles = _a.bundles, listBundles = _a.listBundles, getDevPlanInvoiceDetails = _a.getDevPlanInvoiceDetails, devPlanInvoiceDetails = _a.devPlanInvoiceDetails, devPlanInvoiceDetailsOrg = _a.devPlanInvoiceDetailsOrg, purchase_dev_plan_bundle_loading = _a.purchase_dev_plan_bundle_loading, purchase_dev_plan_bundle_error = _a.purchase_dev_plan_bundle_error;
    var params = useParams();
    var _b = params.organizationId, organizationId = _b === void 0 ? '' : _b;
    var _c = useState(false), openDevPlanCancelConfirmationModal = _c[0], setOpenDevPlanCancelConfirmationModal = _c[1];
    var crumbs = [{ to: '', text: 'Developer Plans' }];
    var organizationName = organization ? organization.name : 'Loading...';
    crumbs = [
        {
            to: '/organizations',
            text: 'Organizations',
        },
        {
            to: "/organizations/".concat(organizationId),
            text: organizationName,
        },
        {
            to: '',
            text: 'Usage',
        },
    ];
    useEffect(function () {
        getDevPlanInvoiceDetails(organizationId);
        getConsumedDevPlan(organizationId);
        listDeveloperPlans(organizationId);
        getActiveBundles(organizationId);
        listBundles(organizationId, activeDeveloperPlan.id);
    }, [
        getDevPlanInvoiceDetails,
        getConsumedDevPlan,
        listDeveloperPlans,
        getActiveBundles,
        listBundles,
        organizationId,
        activeDeveloperPlan.id,
    ]);
    useSuccessToast('Developer plan successfully canceled', [
        !devPlanCancel_loading,
        !devPlanCancel_error,
    ]);
    useSuccessToast('Developer plan successfully activated', [
        !devPlanReactivate_loading,
        !devPlanReactivate_error,
    ]);
    var onCancelDevPlan = function () {
        cancelDevPlan(organizationId);
        setOpenDevPlanCancelConfirmationModal(false);
    };
    useSuccessToast('Developer plan successfully purchased', [
        !developerPlanPurchase_loading,
        !developerPlanPurchase_error,
        !(purchasedDeveloperPlan === null || purchasedDeveloperPlan === void 0 ? void 0 : purchasedDeveloperPlan.client_secret) /*what is this? */,
    ]);
    useSuccessToast('Developer plan successfully Updated', [
        !purchase_dev_plan_bundle_loading,
        !purchase_dev_plan_bundle_error,
    ]);
    return (_jsxs(_Fragment, { children: [_jsx(DevPlanCancelConfirmModal, { isVisible: openDevPlanCancelConfirmationModal, setIsVisible: setOpenDevPlanCancelConfirmationModal, primaryButtonAction: onCancelDevPlan, devPlanStatus: devPlanStatus }), _jsxs(PageWrapper, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Developer Plans" }) }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsx(DevPlanUsageComponent, { devPlanConsume: devPlanConsume, devPlanConsumeOrg: devPlanConsumeOrg, developerPlansOrg: developerPlansOrg, activeDeveloperPlan: activeDeveloperPlan, devPlanStatus: devPlanStatus, devPlanStatusOrg: devPlanStatusOrg, setOpenDevPlanCancelConfirmationModal: setOpenDevPlanCancelConfirmationModal, onReactivateDevPlan: reactivateDevPlan, actionLoading: devPlanCancel_loading ||
                            devPlanReactivate_loading ||
                            devPlanStatusLoading, devPlanStatusLoading: devPlanStatusLoading, activeBundles: activeBundles, activeBundlesOrg: activeBundlesOrg, devPlanInvoiceDetails: devPlanInvoiceDetails, devPlanInvoiceDetailsOrg: devPlanInvoiceDetailsOrg, bundles: bundles })] })] }));
};
var mapStateToProps = function (state) { return (__assign(__assign({ organization: makeSelectOrganization()(state) }, makeSelectDevPlans(state)), { devPlanStatus: selectDevPlanSummery(state), devPlanStatusLoading: selectStatusLoading(state), activeDeveloperPlan: makeSelectActiveDeveloperPlan(state), activeBundles: makeSelectActiveBundles(state), activeBundlesOrg: selectActiveBundlesOrg(state), devPlanConsumeOrg: selectDeveloperPlanConsumeOrg(state), developerPlansOrg: selectDeveloperPlansOrg(state), devPlanStatusOrg: selectStatusSummeryOrg(state), devPlanInvoiceDetails: selectDevPlanInvoiceDetails(state), devPlanInvoiceDetailsOrg: selectDevPlanInvoiceDetailsOrg(state), purchase_dev_plan_bundle_loading: selectPurchaseDevPlanBundleLoading(state), purchase_dev_plan_bundle_error: selectPurchaseDevPlanBundleError(state) })); };
var mapDispatchToProps = function (dispatch) { return ({
    listDeveloperPlans: function (orgId) {
        dispatch(actions.listDeveloperPlansOrg(orgId));
    },
    getConsumedDevPlan: function (OrgId) {
        dispatch(actions.getAllConsumedDeveloperPlan(OrgId));
    },
    cancelDevPlan: function (orgId) {
        dispatch(actions.cancelDevPlan(orgId));
    },
    reactivateDevPlan: function (orgId) {
        dispatch(actions.reactivateDevPlanStatus(orgId));
    },
    getActiveBundles: function (OrgId) { return dispatch(actions.getActiveBundles(OrgId)); },
    listBundles: function (OrgId, DevPlanId) {
        dispatch(actions.listBundlesPurchasableByOrg(OrgId, DevPlanId));
    },
    getDevPlanInvoiceDetails: function (OrgId) {
        dispatch(actions.getDevPlanInvoiceDetails(OrgId));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(OrganizationDeveloperPlansUsage);
